module.exports = __webpack_public_path__ + "img/Angiogenesis-INCA_10X_IC.ab904629.png";